import uniqBy from "lodash/uniqBy";
import uuid from "uuid";

import * as ActionTypes from '../../constants/actionTypes';
// import {errorBox_Show, toggle_modal} from "../../actions/A_Popups";
import {getApiConfig} from '../../utilities/index';
import {setDiscountSections, setDiscountsReceived, setWorkSheetsCount} from "./discountsActions";
import {loadingDialog_show} from "../../actions";
import {errorBox_Show} from "../../actions/A_Popups";
import {getDiscountSectionDefaultWizardLogic, getWorksheetsCount} from "./discountsFunctions";

export const getDiscounts = () => {
  return (dispatch, getState) => {
    const {auth, asCustomer} = getState();
    dispatch({type: ActionTypes.DISCOUNTS_SECTIONS_REQUEST});
    const fabricatorId =  asCustomer.data ? asCustomer.data.fabricatorId : auth.fabricatorId;
    getApiConfig('public/fabricator-discounts/').get(fabricatorId)
      .then((response) => {
        console.log('response getDiscounts->', response);
        //Sort response by order
        const sections = (Array.isArray(response) ? response : []).map(section => {
          if (!section.wizardLogic) {
            section.wizardLogic = getDiscountSectionDefaultWizardLogic()
          }
          let discounts = Array.isArray(section.discounts) ? section.discounts : [];
          if (discounts.length) {
            section.discounts = discounts.map(discount => {
              if (!discount.uuId) {
                discount.uuId = uuid.v4();
              }
            })
            section.discounts = uniqBy(discounts, "uuId");
          }
          return section
        });
        dispatch(setDiscountSections(sections));
        dispatch(setDiscountsReceived(sections));
        dispatch(setWorkSheetsCount(getWorksheetsCount(sections)));
      })
  }
};

export const postDiscounts = () => {
  return (dispatch, getState) => {

    dispatch(loadingDialog_show(true, "Saving...", "Please wait while we are updating your changes."));

    let {discountSections} = getState().discountsState;

    discountSections = discountSections.map((section) => {
      section.discounts = section.discounts.map((discount) => {
        discount.isSubTotal = discount.isSubTotal || false;
        return discount
      });
      return section
    })
    return getApiConfig('fabricator-discounts/upsert').post(discountSections)
      .then(postResponse => {
        console.log('response postDiscounts->', postResponse);
        if (Array.isArray(postResponse) && postResponse.length) {
          discountSections = discountSections.map((discountSection) => {
            const sameResponseSection = postResponse.find(sec => sec.order === discountSection.order);
            if (sameResponseSection) {
              if ((typeof sameResponseSection.id === "number") && (typeof discountSection.id === "string")) {
                discountSection.id = sameResponseSection.id;
              }
              if (Array.isArray(sameResponseSection.discounts) && sameResponseSection.discounts.length) {
                discountSection.discounts = discountSection.discounts.map((discount) => {
                  const sameResponseDiscount = sameResponseSection.discounts.find(dis => dis.order === discount.order);
                  if (sameResponseDiscount && ((typeof sameResponseDiscount.id === "number") && (typeof discount.id === "string"))) {
                    discount.id = sameResponseDiscount.id;
                  }
                  return discount;
                })
              }
            }
            return discountSection
          })
        }
        dispatch(setDiscountSections(discountSections));
        dispatch(setDiscountsReceived(discountSections)); // update backup with new
        dispatch(loadingDialog_show(false));
        return true
      })
      .catch((response) => {
        console.log('error save discounts ->', response);
        dispatch(errorBox_Show({
          title: "Error",
          text: "Discounts save error",
        }));
        dispatch(loadingDialog_show(false));
        return false
      });
  }
};
